// extracted by mini-css-extract-plugin
export default {"text-animate":"AnimateText_text-animate__GtCoK","fadeIn":"AnimateText_fadeIn__SIgiJ"};